export const getObjectId = (entity: string | { id: string }) => {
  return typeof entity === 'string' ? entity : entity.id;
};

/**
 * Resolves a string id or embedded ref that may expose `id` or `_id` (e.g. flow `origin` from the API).
 */
export function resolveRefId(
  ref: string | { id?: string; _id?: string | { toString(): string } } | null | undefined,
): string | undefined {
  if (ref == null) return undefined;
  if (typeof ref === 'string') return ref;
  if (typeof ref.id === 'string' && ref.id.length > 0) return ref.id;
  const oid = ref._id;
  if (oid == null) return undefined;
  if (typeof oid === 'string') return oid;
  return String(oid);
}

/**
 * Id used for flow-scoped player / media APIs: prefer `origin`, fall back to the flow document `id`.
 */
export function resolveFlowEntityIdForPlayers(flow: { id: string; origin?: unknown }): string {
  const fromOrigin = flow.origin != null ? resolveRefId(flow.origin as Parameters<typeof resolveRefId>[0]) : undefined;
  return fromOrigin ?? flow.id;
}

/**
 * Stable LiveContext / player binding id: API `liveBindingFlowId` when present, else legacy master-plan resolution.
 */
export function resolveLiveBindingFlowId(
  flow: { id: string; origin?: unknown; liveBindingFlowId?: string },
  eventSlotId?: string,
): string {
  void eventSlotId;
  if (flow.liveBindingFlowId) {
    return flow.liveBindingFlowId;
  }
  return resolveFlowEntityIdForPlayers(flow);
}
